import { UserSex } from ".";
import IContatto from "./IContatto";
import IDocumento from "./IDocumento";

export default interface IAnagrafica {
    Id: number;
    Nome: string;
    Cognome: string;
    DataNascita: string;
    CF: string;
    Sesso: UserSex;
    Residenza: string;
    Ingresso: string;
    Gruppo: string | null;
    IsArchiviato: boolean;
    Creation: string;
    Timestamp: string;

    //* NotMapped
    IsEducatore: boolean;
    Documenti: IDocumento[];
    Contatti: IContatto[];
}

export const exampleAnagrafica: IAnagrafica = {
    Id: 0,
    Nome: '',
    Cognome: '',
    DataNascita: '',
    CF: '',
    Sesso: UserSex.NONE,
    Residenza: '',
    Ingresso: '',
    Gruppo: null,
    IsArchiviato: false,
    Creation: '',
    Timestamp: '',

    //* NotMapped
    IsEducatore: false,
    Documenti: [],
    Contatti: [],
};